import React from 'react'
import styles from './StatusScreen.module.scss'

/**
 * Full-screen message with up to two actions, for flows that cannot go on
 * without the visitor (a failed sign-in handoff, an account that won't load).
 */
const StatusScreen = ({ title, description, primaryLabel, onPrimary, secondaryLabel, onSecondary }) => (
  <div className={styles.container}>
    <h1 className={styles.title}>{title}</h1>
    {description && <p className={styles.description}>{description}</p>}
    <div className={styles.actions}>
      {primaryLabel && (
        <button type='button' className={styles.primary} onClick={onPrimary}>
          {primaryLabel}
        </button>
      )}
      {secondaryLabel && (
        <button type='button' className={styles.secondary} onClick={onSecondary}>
          {secondaryLabel}
        </button>
      )}
    </div>
  </div>
)

export default StatusScreen
